module.exports = __webpack_public_path__ + "static/media/image001.33991470.webp";